import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b425820"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "openSearch" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "titleStyle" }, "筛选列", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "openSearch_Style1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-s-operation" })
], -1))

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: {
        type: Array,
        default: []
    },
    checkList: {
        type: Array,
        default: []
    }
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props



const checkedColumns = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emit('update:modelValue', val)
    }
})
const checkLists = computed(() => props.checkList)

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      placement: "bottom",
      trigger: "click"
    }, {
      reference: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_checkbox_group, {
          modelValue: _unref(checkedColumns),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checkedColumns) ? (checkedColumns).value = $event : null))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkLists), (item, index) => {
              return (_openBlock(), _createBlock(_component_el_checkbox, {
                key: index,
                label: item
              }, null, 8, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})